import {capitalize} from '@mui/material';
import {HomeEnum, QueryParamsEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {GuideStep} from 'presentation/modules/guide/shared/constants/constants';
import {useGuideQueryParams} from 'presentation/modules/guide/shared/hooks/useGuideQueryParams';
import {ppoNetworkTypeEnum} from 'presentation/modules/guide/shared/store/guideStore/types';
import {usePpoNetworkStore} from 'presentation/modules/guide/shared/store/guideStore/usePpoNetworkStore';
import {useMediaQueries, useQueryParams} from 'presentation/pages';
import {translations} from 'presentation/translations-new';
import {useRef} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

const {location, details, results} = translations['pt-br'].commons;
const {titleNetworkProviderHealth, titleAccreditedNetwork, titleNotreDameHapvidaNetwork} =
	translations['pt-br'].privateFlow.guideFlow;

export function useHealthGuideHeader() {
	const {isMobile} = useMediaQueries();
	const {SEARCH_PARAMS, setSearchParams} = useQueryParams();
	const navigate = useNavigate();
	const {state: routeState} = useLocation();
	const originRouteRef = useRef(routeState);
	const {deleteAllQueryParams} = useGuideQueryParams();
	const {isNotredameSaude} = useHostName();
	const {step: currentStepState, comingFrom} = SEARCH_PARAMS;

	const ppoNetworkTypeState = usePpoNetworkStore(state => state.ppoNetworkType);

	const stepLabels = [location, details, `${capitalize(results)}`];

	const getNetworkTitle = () => {
		if (isNotredameSaude) {
			if (ppoNetworkTypeState === ppoNetworkTypeEnum.SELF_NETWORK) {
				return titleNotreDameHapvidaNetwork;
			}

			if (ppoNetworkTypeState === ppoNetworkTypeEnum.ACCREDITED_NETWORK) {
				return titleAccreditedNetwork;
			}
		}

		return titleNetworkProviderHealth;
	};

	const handleBack = () => {
		if (comingFrom === FlowEnum.EXAM && currentStepState === GuideStep.RESULTS) {
			navigate(-2);
			return;
		}

		if (currentStepState === GuideStep.RESULTS) {
			setSearchParams(prev => {
				prev.set(QueryParamsEnum.STEP, GuideStep.DETAILS);
				prev.delete(QueryParamsEnum.PROCEDURE);
				prev.delete(QueryParamsEnum.DISTANCE);
				prev.delete(QueryParamsEnum.SEARCH_QUERY);
				return prev;
			});
			return;
		}

		if (currentStepState === GuideStep.DETAILS) {
			deleteAllQueryParams();
			return;
		}

		const originRoute = routeState || originRouteRef.current;

		if (originRoute) {
			navigate(originRoute);
			return;
		}

		navigate(HomeEnum.HOME_PAGE);
	};

	const handleClose = () => {
		const originRoute = routeState || originRouteRef.current;

		if (originRoute) {
			navigate(originRoute);
			return;
		}

		navigate(HomeEnum.HOME_PAGE);
	};

	return {
		stepLabels,
		handleBack,
		handleClose,
		isMobile,
		currentStepState,
		getNetworkTitle,
	};
}
